import { render, staticRenderFns } from "./Empty2.vue?vue&type=template&id=166f2b32&scoped=true"
import script from "./Empty2.vue?vue&type=script&lang=js"
export * from "./Empty2.vue?vue&type=script&lang=js"
import style0 from "./Empty2.vue?vue&type=style&index=0&id=166f2b32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f2b32",
  null
  
)

export default component.exports